import { connect } from "react-redux";
import BroadListViewer from "./broadcastList";
import {getBroadcastList} from '../../../redux/actions/broadcast/broadcastList.action'
import { openAlertPopup } from "../../../redux/actions/Alert/alert.action";
import { setStatusFilter } from "../../../redux/actions/filters/filter.action";
const mapStateToProps = (state) => {
 return {
   data:state.broadcast,
   statusCount: state.broadcast.statusCount,
   notifications: state.notifications.moduleNotification.data,
   isLoading:state.broadcast.isLoading,
   myRights : state.myRights.myRights,
   statusFilter: state?.filtersReducer?.status?.BROADCAST,
  };
};

const mapDispatchToProps = (dispatch) => {
    return{
    getBroadcastList: (next=null,status="",orderBy="")=>{
        return dispatch(getBroadcastList(next,status,orderBy))
    },
    setStatusFilter: (screen,data) => {
      return dispatch(setStatusFilter(screen, data))
    },
  }
};

export default connect(mapStateToProps, mapDispatchToProps)(BroadListViewer);
